import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'
import axios from '@/plugins/axios'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'caso/asignadoagruposkillhistory',
    ...crudState(),
    stage: 'todos',
    usuario: 'todos',
    destacados: false,
    prioridad: 'todos',
    seleccion: []
  }),
  getters: {
    ...crudGetters,

    filtroPorStageYPrioridad (state) {
      return state.all.filter(item => (state.stage === 'todos' || state.stage === item.idstageactual) && (state.prioridad === 'todos' || state.prioridad === item.idprioridad) && (!state.destacados || item.destacado))
    },
    filtroPorUsuarioYPrioridad (state) {
      return state.all.filter(item => (state.usuario === 'todos' || state.usuario === item.idusuarioasignado) && (state.prioridad === 'todos' || state.prioridad === item.idprioridad) && (!state.destacados || item.destacado))
    },
    numeroCasosDestacados (state) {
      return state.all.reduce((p, c) => (p + (c.destacado ? 1 : 0)), 0)
    },
    numeroCasosPorStage (state) {
      const todos = state.all.length
      return state.all.reduce((p, c) => {
        if (!p.hasOwnProperty(c.idstageactual)) {
          p[c.idstageactual] = 0
        }
        p[c.idstageactual]++
        return p
      }, { todos })
    },
    numeroCasosPorUsuario (state) {
      const todos = state.all.length
      return state.all.reduce((p, c) => {
        if (!p.hasOwnProperty(c.idusuarioasignado)) {
          p[c.idusuarioasignado] = 0
        }
        p[c.idusuarioasignado]++

        return p
      }, { todos })
    },
    numeroCasosPorPrioridad (state) {
      const todos = state.all.length
      return state.all.reduce((p, c) => {
        if (!p.hasOwnProperty(c.idprioridad)) {
          p[c.idprioridad] = 0
        }
        p[c.idprioridad]++

        return p
      }, { todos })
    },

    seleccion: state => state.seleccion,
    usuario: state => state.usuario
  },
  mutations: {
    ...crudMutations,

    setSeleccion (state, value) {
      state.seleccion = value
    },
    setStage (state, value) {
      state.stage = state.stage === value ? 'todos' : value
    },
    setDestacados (state, value) {
      state.destacados = value
    },
    setPrioridad (state, value) {
      state.prioridad = state.prioridad === value ? 'todos' : value
    },
    setUsuario (state, value) {
      state.usuario = state.usuario === value ? 'todos' : value
    }
  },
  actions: {
    ...crudActions,

    seleccionarCasos ({ commit }, data) {
      commit('setSeleccion', data)
    },
    selectStage ({ commit }, value) {
      commit('setStage', value)
    },
    selectDestacados ({ commit, state }) {
      commit('setDestacados', !state.destacados)
    },
    selectPrioridad ({ commit }, value) {
      commit('setPrioridad', value)
    },
    selectUsuario ({ commit }, value) {
      commit('setUsuario', value)
    },
    async destacar ({ commit, state }, { id, value }) {
      const action = value ? 'fav' : 'unfav'
      try {
        await axios.post(`caso/${action}`, { idcaso: id })
        commit('setProperty', { id, property: 'destacado', value })

        return true
      } catch (e) {
        return Promise.reject(e)
      }
    }
  }
}
